import saveIcon from "../../assets/design-revamp/save-icon.svg";

const SaveIcon = ({ style, onClick }) => {
  return (
    <>
      <div onClick={onClick}>
        <img
          className=""
          src={saveIcon}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default SaveIcon;
